module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"notification-bar-wrapper\" ref=\"notificationBarWrapper\">\n    <div class=\"notification-bar negative invisible\">\n        <div class=\"padded-container\" ref=\"html\">\n            <span class=\"icon warning\"></span>\n            <span class=\"notification\">&nbsp;</span>\n            <span title=\"Close\" class=\"icon close closeIconWhite\" data-ci=\"notification-close-icon\"></span>\n        </div>\n    </div>\n</div>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/__notificationBar.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"notification-bar-wrapper\" ref=\"notificationBarWrapper\">\n    <div class=\"notification-bar negative invisible\">\n        <div class=\"padded-container\" ref=\"html\">\n            <span class=\"icon warning\"></span>\n            <span class=\"notification\">&nbsp;</span>\n            <span title=\"Close\" class=\"icon close closeIconWhite\" data-ci=\"notification-close-icon\"></span>\n        </div>\n    </div>\n</div>\n")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/__notificationBar.tpl"

}